import AuthService from "@/services/auth.service";

import { JWTService, UserService } from "@/storage";

export const LOGIN = "login";
export const LOGOUT = "logout";
export const UPDATE_TOKEN_AND_USER = "updateTokenAndUser";

const AUTHENTICATE = "authenticate";
const DEAUTHENTICATE = "deauthenticate";
const USE_BEARER_AUTH = "setBearerAuth";
const USE_BEARER_ADMIN = "setBearerAdminAuth";

export default {
  state: {
    authenticated: !!JWTService.getToken(),
    user: UserService.getUser(),
    token: JWTService.getTokenType(),
  },
  getters: {
    authenticated(state) {
      return state.authenticated;
    },
    user(state) {
      return state.user;
    },
    getFullToken(state) {
      return (token_value) => `${state.token} ${token_value}`;
  },
  },
  actions: {
    [LOGIN]({ commit }, credentials) {
      return new Promise((resolve, reject) => {
        AuthService.login(credentials)
          .then(({ data }) => {
            commit(AUTHENTICATE, data.data);
            commit(USE_BEARER_ADMIN);

            resolve(data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    [LOGOUT]({ commit }) {
      commit(DEAUTHENTICATE);
    },
    [UPDATE_TOKEN_AND_USER]({commit}, {token, user}) {
      commit(AUTHENTICATE, {token, user});
  },
  },
  mutations: {
    [AUTHENTICATE](state, { token, user }) {
      state.authenticated = true;
      state.user = user;

      JWTService.setToken(token);
      UserService.setUser(user);
    },
    [DEAUTHENTICATE](state) {
      state.authenticated = false;
      state.user = {};

      JWTService.removeToken();
      UserService.removeUser();
    },
    [USE_BEARER_AUTH](state) {
        state.token = 'Bearer';
        JWTService.setTokenType('Bearer');
    },
    [USE_BEARER_ADMIN](state) {
        state.token = 'Bearer-Admin';
        JWTService.setTokenType('Bearer-Admin');
    },
  },
};
